import {
    ReturnStockInterface,
    StockItemInterface,
    UpdateStockInterface,
} from '../../types/stock';
import { getRequest, postRequest, putRequest } from '../client';

export const fetchStock = async () => {
    const data = await getRequest<StockItemInterface[]>('api/stock');

    return data;
};

export const updateStock = async (
    stockNumber: string,
    stock: UpdateStockInterface
) => {
    const data = await putRequest<any>(`api/stock/${stockNumber}`, stock);

    return data;
};

export const returnStock = async (
    stockNumber: string,
    returnStock: ReturnStockInterface
) => {
    const data = await postRequest<any>(
        `api/stock/${stockNumber}/return`,
        returnStock
    );

    return data;
};
